<div class="loading">
    <mat-spinner></mat-spinner>
    <p class="loading-message" *ngIf="loadingMessage">{{ loadingMessage }} </p>
</div>
